import { DeprecatedCombobox } from '@qogita/ui';
import DOMPurify from 'dompurify';

import { SearchItem } from '#components/shared/SearchBar/SearchBarSeller';
import { getEmphasizedTextHtml } from '#utils/getEmphasizedTextHtml';

type SearchBarHitProps = {
  query: string | undefined;
  index: number;
  item: SearchItem;
  headerTitle?: string;
  headerIcon?: React.ElementType;
  href: string;
  title: string;
  description?: string;
  objectID: string;
};

export const SearchBarHit = ({
  query,
  title,
  headerTitle,
  headerIcon: HeaderIcon,
  description,
  item,
}: SearchBarHitProps) => {
  const label = query ? getEmphasizedTextHtml(title, query) : title;
  const highlightedDescription =
    query && description
      ? ` - ${getEmphasizedTextHtml(description, query)}`
      : '';

  const sanitizedLink = DOMPurify.sanitize(`${label}${highlightedDescription}`);

  const hasOptionsHeader = !!headerTitle && !!HeaderIcon;

  return (
    <>
      {hasOptionsHeader ? (
        <div
          className={
            'text-md flex cursor-not-allowed gap-3 bg-white px-3 py-2 text-base text-gray-900'
          }
        >
          <HeaderIcon className="mt-1 h-4 w-4" /> {headerTitle}
        </div>
      ) : null}

      <DeprecatedCombobox.Option key={item.qid} value={item}>
        <div dangerouslySetInnerHTML={{ __html: sanitizedLink }} />
      </DeprecatedCombobox.Option>
    </>
  );
};
